import { QueryClient } from '@tanstack/react-query';

// Centralized QueryClient instance used across the app
// Optimized for performance: reduces unnecessary refetches and setTimeout usage
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 2,
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
      refetchOnMount: false,
      // Increase staleTime to reduce unnecessary refetches
      staleTime: 1000 * 60 * 5, // 5 minutes default
      // Increase gcTime (formerly cacheTime) to keep data longer
      gcTime: 1000 * 60 * 30, // 30 minutes default
      // Use networkMode: 'online' to prevent refetches when offline
      networkMode: 'online',
      // Reduce retry delay to minimize setTimeout violations
      // React Query uses exponential backoff: delay = Math.min(1000 * 2 ** attemptIndex, 30000)
      // We can't directly control this, but reducing retries helps
      retryDelay: attemptIndex => Math.min(1000 * 2 ** attemptIndex, 5000), // Max 5s instead of 30s
    },
  },
});
